import CookiesJS from 'cookies-js';

export function initEmails($, apiClient) {
    $('form.email-form .action__entity-save').on('click', async function () {
        try {
            const email = {
                to: $('#to').val(),
                templateName: $('#templateName').val(),
                templateParams: JSON.parse($('#templateParams').val())
            };
            const result = await apiClient.create('/emails', email, CookiesJS.get('auth_token'));
            console.log(result);
            document.location.href=`/emails/edit/${result._id}`;
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
